var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_5407)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 0.833374C4.04188 0.833374 0.833252 4.042 0.833252 8.00004C0.833252 11.9581 4.04188 15.1667 7.99992 15.1667C11.958 15.1667 15.1666 11.9581 15.1666 8.00004C15.1666 4.042 11.958 0.833374 7.99992 0.833374ZM8.66658 5.33337C8.66658 4.96519 8.36812 4.66671 7.99992 4.66671C7.63172 4.66671 7.33325 4.96519 7.33325 5.33337V8.00004C7.33325 8.17684 7.40352 8.34644 7.52852 8.47144L8.86185 9.80477C9.12218 10.0651 9.54432 10.0651 9.80465 9.80477C10.065 9.54444 10.065 9.12231 9.80465 8.86197L8.66658 7.72391V5.33337Z",
    fill: "#172B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_5407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock2);
export default __webpack_public_path__ + "static/media/clock 2.4a0e61ace9392c1e8e62aed45b8b5d02.svg";
export { ForwardRef as ReactComponent };